import React from 'react';
import { Tag, X } from 'lucide-react';

export const productQuickReplies = (cfg, product) => (cfg?.product_quick_replies || [])
  .map((q) => q.replaceAll('{produkt}', product.name))
  .filter((q) => (product.hasKids !== false || !/kinder/i.test(q)) && (product.hasSize !== false || !/platz/i.test(q)));

export const ProductContextBar = ({ product, cfg, busy, showChips, onAsk, onDismiss }) => (
  <div className="border-t bg-sky-50/70 px-2.5 pt-1.5 pb-1.5 space-y-1.5" data-testid="ai-product-context">
    <div className="flex items-center gap-1.5 text-[11px] text-sky-900">
      <Tag className="w-3.5 h-3.5 shrink-0" />
      <span className="truncate">Frage zu: <strong data-testid="ai-product-context-name">{product.name}</strong></span>
      <button type="button" onClick={onDismiss} title="Ohne Produktbezug fragen" className="ml-auto p-0.5 rounded hover:bg-sky-100" data-testid="ai-product-context-dismiss"><X className="w-3.5 h-3.5" /></button>
    </div>
    {showChips && (
      <div className="flex flex-wrap gap-1.5" data-testid="ai-product-quick-replies">
        {productQuickReplies(cfg, product).slice(0, 4).map((q, i) => (
          <button key={q} type="button" disabled={busy} onClick={() => onAsk(`${q} (${product.name})`)}
            className="rounded-full border border-sky-200 bg-white px-2.5 py-1 text-[11px] font-semibold text-sky-900 hover:bg-sky-100 disabled:opacity-50"
            data-testid={`ai-product-quick-${i}`}>{q}</button>
        ))}
      </div>
    )}
  </div>
);
